import { inject, Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { Order } from 'gung-standard';
import { JeevesOrderListConfigService } from 'gung-standard-jeeves';
import { mergeMap, Observable, of } from 'rxjs';
import { SjoborgOrderCardListComponent } from '../components/sjoborg-order-card-list/sjoborg-order-card-list.component';
import { SjoborgOrderService } from './sjoborg-order.service';

@Injectable({
  providedIn: 'root'
})
export class SjoborgOrderListConfigService extends JeevesOrderListConfigService {
  protected sjoborgOrderService = inject(SjoborgOrderService);

  // Undefined uses the backend default from SjoborgsOrderTrackingConfig
  trackingDaysBack?: number;

  getItems(): Observable<Order[]> {
    if (this.customerId == null) {
      return this.selectedCustomerService.getSelectedCustomer().pipe(
        mergeMap(customer => {
          if (customer != null) {
            return this.getUnfinishedOrders(customer.id);
          } else {
            return of([]);
          }
        })
      );
    } else {
      return this.getUnfinishedOrders(this.customerId);
    }
  }

  protected getUnfinishedOrders(customerId: string): Observable<Order[]> {
    return this.sjoborgOrderService
      .getOrdersWithTracking(customerId, this.trackingDaysBack)
      .pipe(mergeMap((orders: Order[]) => of(orders.filter(o => o.extra.oh.ordstat !== 90))));
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgOrderCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Order list'
      }
    ];
  }
}
